import AbstractField from "./abstract";

class FileField extends AbstractField{
    __init_dom_schema(){
        return {
            input: {
                selector: 'input[type="file"]',
                actions: {
                    'change': this.onSelected.bind(this)
                }
            },
            title: '.js-fileinput-title',
            wrapper: {
                selector: '.js-form-field__wrapper',
                actions: {
                    'click|touch': this.openDialog.bind(this)
                }
            }
        }
    }
    __init(){
        this.registerEvents('changed')
    }
    isRequired(){
        // console.log(this)
        return this.dom.input.hasAttribute('required')
    }
    isFilled(){
        return this.dom.input.value !== ''
    }
    getValue(){
        return this.dom.input.value
    }
    openDialog(event){
        event.stopPropagation()
        this.dom.input.click()
        this.focus()
    }
    onSelected(event){
        const name = this.dom.input.value.split(/(\\|\/)/g).pop()
        this.dom.title.innerHTML = name

        this.dispatchEvent('changed')
    }
    unfocus(){
        
    }
}

export default FileField